import React, { useEffect } from 'react'
import AbsenceRequestConflictsCard from 'redesign/components/organisms/absence-request-conflict-card'
import BalanceModal from 'redesign/components/organisms/modals/balance-modal'
import type { AbsenceRequestDetailsContentProps } from '../task-details/types'
import Timeline from '../timeline'
import { Container } from './styles'

const AbsenceRequestDetailsContent: React.FC<AbsenceRequestDetailsContentProps> = ({
  showConflicts,
  dateFrom,
  dateTo,
  showAbsencePlannerDrawer,
  setShowAbsencePlannerDrawer,
  previewPerson,
  isOffice,
  items: timelineItems,
  task,
  isBalanceDrawerOpen,
  onCloseBalanceModal,
  extraPaddingTop,
}) => {
  const scrollRef = React.useRef<HTMLDivElement>(null)

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [scrollRef, timelineItems])

  return (
    <Container extraPaddingTop={extraPaddingTop}>
      <Timeline items={timelineItems} isOffice={isOffice} />
      {showConflicts && (
        <AbsenceRequestConflictsCard
          startDate={dateFrom as string}
          endDate={dateTo as string}
          isOffice={isOffice}
          showAbsencePlannerPreview
          showAbsencePlannerDrawer={showAbsencePlannerDrawer}
          setShowAbsencePlannerDrawer={setShowAbsencePlannerDrawer}
          previewPerson={previewPerson}
        />
      )}
      <BalanceModal task={task} open={isBalanceDrawerOpen} onClose={onCloseBalanceModal} />
      <div ref={scrollRef}></div>
    </Container>
  )
}

export default AbsenceRequestDetailsContent
